import { render, staticRenderFns } from "./SimpleChart.vue?vue&type=template&id=0cdb5d59&scoped=true&"
import script from "./SimpleChart.vue?vue&type=script&lang=js&"
export * from "./SimpleChart.vue?vue&type=script&lang=js&"
import style0 from "./SimpleChart.vue?vue&type=style&index=0&id=0cdb5d59&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cdb5d59",
  null
  
)

export default component.exports